import { Misc } from '@singularsystems/neo-core';
import { containerId } from './TooltipProvider';
var arrowHeight = 6;
var TooltipHelper = /** @class */ (function () {
    function TooltipHelper() {
    }
    TooltipHelper.showTooltip = function (on, content, isHtml, aligmnent, position, className) {
        this.toolTipContainer = Misc.Globals.root.getElementById(containerId);
        if (this.toolTipContainer) {
            var ttText = this.toolTipContainer.firstChild;
            if (isHtml) {
                ttText.innerHTML = content;
            }
            else {
                ttText.innerText = content;
            }
            TooltipHelper.positionTooltip(this.toolTipContainer, on, aligmnent, position, className);
            this.toolTipContainer.classList.add("show");
        }
        else {
            console.error("Tooltip: TooltipProvider has not been added to the app.");
        }
    };
    TooltipHelper.hideTooltip = function () {
        if (this.toolTipContainer) {
            this.toolTipContainer.classList.remove("show");
        }
    };
    TooltipHelper.positionTooltip = function (toolTipContainer, anchor, alignment, position, className) {
        var isHorizontal = position === "left" || position === "right";
        toolTipContainer.className = "neo-tooltip" + (isHorizontal ? " horizontal" : "");
        if (className) {
            toolTipContainer.classList.add(className);
        }
        var ttArrow = toolTipContainer.lastChild;
        var bgColor = window.getComputedStyle(toolTipContainer).backgroundColor;
        var startName = isHorizontal ? "top" : "left", endName = isHorizontal ? "bottom" : "right", dimensionName = isHorizontal ? "height" : "width", alignName = isHorizontal ? "left" : "top", endAlignName = isHorizontal ? "right" : "bottom", alignDimensionName = isHorizontal ? "width" : "height";
        toolTipContainer.style.top = "0";
        toolTipContainer.style.left = "0";
        var ttRect = toolTipContainer.getBoundingClientRect();
        var anchorRect = anchor.getBoundingClientRect();
        if (alignment === "start-edge") {
            alignment = (anchorRect[startName] + ttRect[dimensionName] + 20 > window[this.getPrefixedWindowKey("inner", dimensionName)]) ? "end" : "start";
        }
        else if (alignment === "end-edge") {
            alignment = (anchorRect[endName] - ttRect[dimensionName] < 15) ? "start" : "end";
        }
        var start = anchorRect[startName] + (anchorRect[dimensionName] - ttRect[dimensionName]) / 2;
        var arrowPosition = anchorRect[dimensionName] / 2;
        if (alignment === "start") {
            start = anchorRect[startName];
            arrowPosition = 20;
        }
        else if (alignment === "end") {
            start = anchorRect[endName] - ttRect[dimensionName];
            arrowPosition = anchorRect[dimensionName] - 20;
        }
        // Check if the tooltip is going to go off the edge of the screen.
        var clampedStart = Math.max(Math.min(start, window[this.getPrefixedWindowKey("inner", dimensionName)] - ttRect[dimensionName] - 20), 15);
        var arrowOffset = anchorRect[startName] - clampedStart;
        ttArrow.removeAttribute("style");
        ttArrow.style[startName] = (arrowOffset + arrowPosition) + "px";
        var align = anchorRect[alignName] - ttRect[alignDimensionName] - arrowHeight;
        if ((align < 20 || position === endAlignName) && anchorRect[endAlignName] + ttRect[alignDimensionName] + arrowHeight + 20 < window[this.getPrefixedWindowKey("inner", alignDimensionName)]) {
            align = anchorRect[endAlignName] + arrowHeight;
            ttArrow.style[this.getPrefixedStyleName("border", endAlignName)] = "5px solid " + bgColor;
            ttArrow.style[this.getPrefixedStyleName("border", alignName)] = "none";
            ttArrow.style[alignName] = "-5px";
        }
        else {
            // Show above
            ttArrow.style[this.getPrefixedStyleName("border", alignName)] = "5px solid " + bgColor;
            ttArrow.style[this.getPrefixedStyleName("border", endAlignName)] = "none";
            ttArrow.style[endAlignName] = "-5px";
        }
        toolTipContainer.style[alignName] = align + (isHorizontal ? window.scrollX : window.scrollY) + "px";
        toolTipContainer.style[startName] = clampedStart + (isHorizontal ? window.scrollY : window.scrollX) + "px";
    };
    TooltipHelper.getPrefixedWindowKey = function (prefix, styleName) {
        return prefix + styleName[0].toUpperCase() + styleName.substring(1);
    };
    TooltipHelper.getPrefixedStyleName = function (prefix, styleName) {
        // This can return any style name, but is cast as "borderLeft" to keep typescript happy.
        return prefix + styleName[0].toUpperCase() + styleName.substring(1);
    };
    return TooltipHelper;
}());
export { TooltipHelper };
